import { DecimalPipe } from '@angular/common';
import { Directive, ElementRef, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appInputDecimalFormat]',
  providers: [DecimalPipe],
})
export class InputDecimalFormatDirective {

  constructor(
    private el: ElementRef,
    private control: NgControl,
    private decimalPipe: DecimalPipe,
  ) { }

  @HostListener('input', ['$event']) onInput() {
    if (this.el.nativeElement.value) {
      const newValue = this.el.nativeElement.value.replace(/[^0-9\,]/g, '');
      // const formatValue = this.decimalPipe.transform(newValue, '1.0-1');
      this.control.control?.setValue(newValue);
    }
  }

}
